// Rooted — shared brand & feature data.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_rooted-app-site/artifacts/gsu8tq6y_42E8691B-4C32-4BB0-9876-3AAC2A67CE7E__1_-removebg-preview-removebg-preview.png";

export const VERSE_TEXT =
  "Rooted and built up in him, and stablished in the faith, as ye have been taught, abounding therein with thanksgiving.";
export const VERSE_CITE = "Colossians 2:7 (KJV)";

export const LAUNCH_STATUS = "Coming Soon · In Development";

export const NOTIFICATION_IMG =
  "https://customer-assets.emergentagent.com/job_rooted-app-site/artifacts/s5kfh263_notification.PNG";

// App screenshots keyed by feature (Learn More page).
export const SCREENSHOTS = {
  reflectionJournal:
    "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/k8c2lt68_Reflection%20Journal.webp",
  verseVault:
    "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/6go5qr4d_VerseVault.webp",
  grove:
    "https://customer-assets.emergentagent.com/job_rooted-app-site/artifacts/blo6sovt_The%20Grove%202.PNG",
};

export const INSIGHTS_VIDEO =
  "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/z25eevfh_copy_8A36346A-8D71-4B25-804E-38C628815787.mov";

export const MEMORY_GARDEN_VIDEO =
  "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/s5r127y6_Memory%20Garden.mp4";

// Google Apps Script endpoint mirror for waitlist.
export const WAITLIST_SHEETS_URL =
  "https://script.google.com/macros/s/AKfycbwqPp-dkhiOuuPiSzVy7zNI8kNtwVV3OTFN8_bl1_00VD7r7Uxc8bYC9dmIoLRrWD6D/exec";

/* ---------- Carousels for the three narrative blocks ---------- */

export const POD_CAROUSEL = {
  label: "Pods",
  steps: [
    {
      title: "Create or Join a Pod",
      subtitle: "Start a group or join one with a simple code.",
      image:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/wo6uhm2q_Pod_1.webp",
    },
    {
      title: "Read the Same Passage Together",
      subtitle: "Everyone opens the same verses, at the same time.",
      image:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/6c0ujl27_Pod_2.webp",
    },
    {
      title: "Highlight, Scribble, and Share Insights",
      subtitle: "Mark up the passage and add your own thoughts.",
      video:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/nixruxwi_Pod_3.mp4",
    },
    {
      title: "See Everyone's Reflections Come In",
      subtitle: "Watch your group's insights appear as they finish.",
      video:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/2tb83hyb_Pod_4.mp4",
    },
  ],
};

export const DAILY_CHALLENGE_CAROUSEL = {
  label: "Daily Challenge",
  steps: [
    {
      title: "Receive Your Daily Verse",
      subtitle: "A new verse waiting for you every morning.",
      image:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/gpxqa74c_DailyChallenge_1.webp",
    },
    {
      title: "Get a Real Life Challenge",
      subtitle: "A small, doable way to put it into practice.",
      video:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/ek1ugmj9_DailyChallenge_2.mp4",
    },
    {
      title: "Live It Out",
      subtitle: "Go and do it, however small it seems.",
      video:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/i6t5nl7s_DailyChallenge_3.mp4",
    },
    {
      title: "Share It or Keep It Private",
      subtitle: "Let your circle see it, or keep it in your journal.",
      video:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/dosac65h_DailyChallenge_4.mp4",
    },
  ],
};

export const JOURNEY_CAROUSEL = {
  label: "Journey",
  steps: [
    {
      title: "Show Up Each Day",
      subtitle: "In a Pod or on your own, it all counts.",
      image:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/zb2dl92l_Screenshot%202026-07-30%20124128.png",
    },
    {
      title: "Watch Your Plant Grow",
      subtitle: "A visual picture of your walk taking root.",
      image:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/0iiftpyc_Arkling_2.webp",
    },
    {
      title: "Collect Arklings Along the Way",
      subtitle: "Little companions from Scripture, earned as you go.",
      image:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/xaxuvk2d_Arkling_3.webp",
    },
    {
      title: "Look Back on Your Growth",
      subtitle: "See how far you have come, anytime.",
      video:
        "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/onako71p_Arkling_4.mp4",
    },
  ],
};

/* ---------- Learn More page items (image-forward) ---------- */

const GREEN = "#39971a";
const AMBER = "#C89B3C";

export const LEARN_MORE_FEATURES = [
  {
    key: "the-grove",
    title: "The Grove",
    accent: GREEN,
    image: SCREENSHOTS.grove,
    summary:
      "A guided overview of the Bible itself, covering books, outlines, and timelines, for anyone who wants a clearer map of Scripture as a whole.",
  },
  {
    key: "journey",
    title: "Journey",
    accent: GREEN,
    video:
      "https://customer-assets-lqy194kg.emergentagent.net/job_rooted-app-site/artifacts/ppul9b47_Arkling_4.mp4",
    summary:
      "Showing up in your Pods builds your Journey. Your Plant grows over time, a simple, visible picture of your walk taking root, and along the way you collect Arklings, small companions drawn from Scripture, each one carrying a short piece of biblical insight about the creature it represents.",
  },
  {
    key: "insights",
    title: "Insights",
    accent: GREEN,
    video: INSIGHTS_VIDEO,
    summary:
      "A look back at everything your reading has built. See the insights you and your Pods have gathered, your most read books of the Bible, and your saved study sessions, all in one place.",
  },
];

/* Rooted Pro — text-only section that lives at the bottom of the Learn More page. */
export const ROOTED_PRO = {
  title: "Rooted Pro",
  accent: AMBER,
  headline: "Everything in Rooted, plus room to grow the Pods you already lead.",
  intro:
    "Rooted Pro is scoped to expansion features inside Pods, for groups that have outgrown the basics and want more room to lead.",
  features: [
    {
      title: "Lead more than one Pod",
      body: "Run several Pods at once — one for your small group, one for your family, one for your closest friends.",
    },
    {
      title: "Grow the size of a Pod",
      body: "Higher member caps so larger groups can read, highlight, and reflect together in the same space.",
    },
    {
      title: "Full Pod history",
      body: "Track and reflect on everything your Pod has read together, well beyond the last ten days.",
    },
    {
      title: "More scribble colours",
      body: "A wider palette for highlighting and margin notes so different people, themes, or passes stay clearly organised.",
    },
    {
      title: "More to come",
      body: "Pro is where Pod expansion lives — new tools land here first as groups tell us what they need.",
    },
  ],
};
